import * as React from 'react'

export interface IProps {}
export const AninixProIcon: React.FCC<IProps> = () => (
  <svg
    width="90"
    height="50"
    viewBox="0 0 90 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `translateX(20px)` }}
  >
    <rect width="48" height="48" rx="24" fill="#374FD5" />
    <path
      d="M31.9688 23.5781L20.8594 33.4688V15.1875L16.9219 17.2504V37.0781L19.4062 39.0938L37.6875 22.6875L19.125 7.96875L15.1875 10.0312L31.9688 23.5781Z"
      fill="white"
    />
    <rect x="37" y="27" width="52" height="22" rx="11" fill="#1BC47D" />
    <rect
      x="37"
      y="27"
      width="52"
      height="22"
      rx="11"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M45 37.3333L48.3333 40.6667L55 34"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.6391 39.2783V38.126H63.4457C63.8689 38.126 64.1977 38.0186 64.432 37.8037C64.6697 37.5856 64.7885 37.2764 64.7885 36.876V36.8662C64.7885 36.4658 64.6697 36.1582 64.432 35.9434C64.1977 35.7285 63.8689 35.6211 63.4457 35.6211H61.6391V34.4541H63.807C64.3018 34.4541 64.7348 34.555 65.1059 34.7568C65.477 34.9554 65.765 35.2354 65.9701 35.5967C66.1785 35.958 66.2826 36.3796 66.2826 36.8613V36.8711C66.2826 37.3561 66.1785 37.7793 65.9701 38.1406C65.765 38.502 65.477 38.7819 65.1059 38.9805C64.7348 39.179 64.3018 39.2783 63.807 39.2783H61.6391ZM60.9018 41.5V34.4541H62.3764V41.5H60.9018ZM67.84 41.5V34.4541H70.7746C71.3085 34.4541 71.7626 34.5452 72.1369 34.7275C72.5145 34.9066 72.801 35.1637 72.9963 35.499C73.1949 35.8343 73.2941 36.2331 73.2941 36.6953V36.7051C73.2941 37.1576 73.1818 37.5645 72.9572 37.9258C72.7359 38.2839 72.4234 38.5426 72.0197 38.7021L73.5041 41.5H71.8342L70.5207 38.9219C70.5109 38.9219 70.4995 38.9219 70.4865 38.9219C70.4735 38.9219 70.4621 38.9219 70.4523 38.9219H69.3146V41.5H67.84ZM69.3146 37.8477H70.6135C70.9813 37.8477 71.2678 37.75 71.4729 37.5547C71.6812 37.3561 71.7854 37.0827 71.7854 36.7344V36.7246C71.7854 36.3828 71.6796 36.111 71.468 35.9092C71.2564 35.7074 70.965 35.6064 70.5939 35.6064H69.3146V37.8477ZM78.0645 41.6807C77.3678 41.6807 76.7656 41.5309 76.2578 41.2314C75.75 40.9287 75.3577 40.5007 75.0811 39.9473C74.8076 39.3939 74.6709 38.738 74.6709 37.9795V37.9697C74.6709 37.208 74.8092 36.5521 75.0859 36.002C75.3659 35.4486 75.7598 35.0221 76.2676 34.7227C76.7754 34.4232 77.3743 34.2734 78.0645 34.2734C78.7578 34.2734 79.3568 34.4232 79.8613 34.7227C80.3691 35.0221 80.7614 35.4486 81.0381 36.002C81.3148 36.5553 81.4531 37.2113 81.4531 37.9697V37.9795C81.4531 38.738 81.3148 39.3939 81.0381 39.9473C80.7646 40.5007 80.374 40.9287 79.8662 41.2314C79.3584 41.5309 78.7578 41.6807 78.0645 41.6807ZM78.0645 40.4307C78.4453 40.4307 78.7773 40.3298 79.0605 40.1279C79.3438 39.9261 79.5618 39.6413 79.7148 39.2734C79.8711 38.9056 79.9492 38.4743 79.9492 37.9795V37.9697C79.9492 37.4717 79.8711 37.0404 79.7148 36.6758C79.5618 36.3079 79.3438 36.0247 79.0605 35.8262C78.7773 35.6243 78.4453 35.5234 78.0645 35.5234C77.6836 35.5234 77.3516 35.6243 77.0684 35.8262C76.7852 36.0247 76.5654 36.3079 76.4092 36.6758C76.2529 37.0404 76.1748 37.4717 76.1748 37.9697V37.9795C76.1748 38.4743 76.2513 38.9056 76.4043 39.2734C76.5605 39.6413 76.7786 39.9261 77.0586 40.1279C77.3418 40.3298 77.6771 40.4307 78.0645 40.4307Z"
      fill="white"
    />
  </svg>
)

AninixProIcon.displayName = 'AninixProIcon'
